import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { store as sarsaparillaStore } from 'sarsaparilla';

import rootReducer from './reducers';
import moduleStore from '../src/store';

const initialState = {
  ...moduleStore(),
  ...sarsaparillaStore()
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancer(
    applyMiddleware(thunk)
  )
);

export default store;